import React from 'react';
import { Chip } from '@mui/material';
// Issue #640: Renamed from StoryPhase to StoryTransPhase to clarify scope
import { STORY_TRANS_PHASE_CONFIG, StoryTransPhase } from '@musedrops/shared';

interface PhaseChipProps {
  phase: StoryTransPhase;
  count?: number;
  suffix?: string;
  size?: 'small' | 'medium';
}

/**
 * Displays a phase chip with optional count and suffix text.
 * Uses STORY_TRANS_PHASE_CONFIG for consistent emoji, label, and color.
 *
 * @example
 * <PhaseChip phase="PUBLISHED" count={9} suffix="(Ignored)" />
 * // Shows: "🔥 Published (Ignored): 9"
 *
 * <PhaseChip phase="READY_FOR_PUBLISH" count={5} />
 * // Shows: "🟢 Ready: 5"
 */
export const PhaseChip: React.FC<PhaseChipProps> = ({
  phase,
  count,
  suffix,
  size = 'small',
}) => {
  const config = STORY_TRANS_PHASE_CONFIG[phase];

  // Build label: "emoji label [suffix]: count"
  let label = `${config.emoji} ${config.label}`;

  if (suffix) {
    label += ` ${suffix}`;
  }

  if (count !== undefined) {
    label += `: ${count}`;
  }

  return (
    <Chip
      label={label}
      size={size}
      color={config.color}
      sx={{ mr: 1, mb: 1 }}
    />
  );
};
